// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world

$w.onReady(function () {

	$w('#pageTitle').html = `<h1 style="text-shadow: 0px 0px 90px black;class="font_0">MANIFESTO</h1>`;
	$w('#pageSubTitle').html = `<h1 style="text-shadow: 0px 0px 15px black;class="font_0">VOL 16</h1>`;
});